import { Injectable, Injector } from '@angular/core';

import { Utilities_FrontendFlowService } from './Utilities.frontend.flow.index';
import { IntraOne_FrontendFlowService } from './IntraOne.frontend.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FrontendFlowService {

  constructor(
    public Utilities: Utilities_FrontendFlowService,
    public IntraOne: IntraOne_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public app: app_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
